export default "__VITE_ASSET__DGHRNx8a__"